<li [class.error]="!passesValidation()">
  @if (passesValidation()) {
    <mat-icon class="check">check</mat-icon>
  } @else {
    <mat-icon class="close">close</mat-icon>
  }
  {{ validationText() }}
</li>
